<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Frame 3">
    <g id="Logo">
      <path
        id="Vector"
        d="M21.141 12.205C21.1417 11.5917 21.0899 10.9794 20.986 10.375H12.4988V13.8412H17.3599C17.2604 14.3948 17.0499 14.9225 16.741 15.3925C16.432 15.8625 16.0312 16.2652 15.5625 16.5761V18.826H18.4636C20.1623 17.2598 21.141 14.9436 21.141 12.205Z"
        fill="#4285F4"
      />
      <path
        id="Vector_2"
        d="M12.4978 21C14.9264 21 16.9714 20.2025 18.4625 18.8275L15.5614 16.5776C14.754 17.1251 13.714 17.4376 12.4978 17.4376C10.1504 17.4376 8.158 15.8551 7.44553 13.7227H4.45691V16.0413C5.20596 17.5319 6.35455 18.7849 7.77444 19.6605C9.19433 20.5362 10.8296 20.9999 12.4978 21Z"
        fill="#34A853"
      />
      <path
        id="Vector_3"
        d="M7.44692 13.7231C7.07026 12.6057 7.07026 11.3956 7.44692 10.2782V7.95947H4.4583C3.82817 9.21338 3.5 10.5973 3.5 12.0006C3.5 13.404 3.82817 14.7878 4.4583 16.0418L7.44692 13.7231Z"
        fill="#FBBC04"
      />
      <path
        id="Vector_4"
        d="M12.4978 6.56299C13.7812 6.54203 15.0214 7.02695 15.9502 7.91296L18.5188 5.34428C16.89 3.81441 14.7322 2.97449 12.4978 3.00059C10.8296 3.00067 9.19433 3.4644 7.77444 4.34001C6.35455 5.21562 5.20596 6.46865 4.45691 7.95921L7.44553 10.2779C8.158 8.14545 10.1504 6.56299 12.4978 6.56299Z"
        fill="#EA4335"
      />
    </g>
  </g>
</svg>
